import { render, staticRenderFns } from "./TftUiBracketItemPlayer.vue?vue&type=template&id=435aa50d"
import script from "./TftUiBracketItemPlayer.vue?vue&type=script&lang=js"
export * from "./TftUiBracketItemPlayer.vue?vue&type=script&lang=js"
import style0 from "./TftUiBracketItemPlayer.vue?vue&type=style&index=0&id=435aa50d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports